
import {
  computed,
  defineComponent,
  PropType,
  reactive,
  toRefs,
  UnwrapNestedRefs,
  watch,
} from "vue";
import { throttle } from "lodash-es";
import { BListGroupItem } from "bootstrap-vue";

interface State {
  searchText: string;
  searchResults: unknown[];
  isInputFocused: boolean;
  isListHovered: boolean;
  targetIndex: number | null;
  items: BListGroupItem[];
  isListVisible: boolean;
}

export default defineComponent({
  props: {
    options: {
      type: Array as PropType<unknown[]>,
      default: () => [],
    },
    labelProp: {
      type: String,
      default: "label",
    },
  },
  setup(props, { emit }) {
    const state: UnwrapNestedRefs<State> = reactive({
      searchText: "",
      searchResults: [],
      isInputFocused: false,
      isListHovered: false,
      targetIndex: null,
      items: [],
      isListVisible: computed(
        () => state.isInputFocused || state.isListHovered
      ),
    });

    function changeSelection(step: number) {
      if (state.targetIndex === null) {
        state.targetIndex = 0;
        if (step > 0) {
          return;
        }
      }
      state.targetIndex =
        (state.targetIndex + step + props.options.length) %
        props.options.length;
    }

    function selectOption(addressOption: unknown | undefined) {
      emit("select", addressOption);
      state.searchText = "";
      state.targetIndex = null;
    }

    watch(
      () => state.searchText,
      throttle((s) => emit("search", s), 1000, { trailing: true }),
      { immediate: true }
    );

    watch(
      () => state.targetIndex,
      (val) => {
        const item = val !== null && state.items[val];
        item && item.$el.scrollIntoView({ block: "nearest" });
      }
    );

    return {
      ...toRefs(state),
      changeSelection,
      selectOption,
    };
  },
  emits: ["select", "search"],
});
